import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { IUserDto } from "../interface/dto/list-builder-users.dto";
import { fetchListBuilderUsers } from "../service/list-builder-users.api";

const {
    actions: listBuilderUsersActions,
    reducer: listBuilderUsersReducer,
    epic: listBuilderUsersEpic,
} = createIGSERedux<Array<IUserDto>>({
    actionNames: {
        init: "LIST_BUILDER_USERS_INIT",
        get: "LIST_BUILDER_USERS_GET",
        success: "LIST_BUILDER_USERS_SUCCESS",
        error: "LIST_BUILDER_USERS_ERROR",
    },
    fetcher: () => fetchListBuilderUsers(selectAuthTokens()),
    selector: (state: IRootState) => state.listBuilderTable.listBuilderUsers,
});

export {
    listBuilderUsersActions,
    listBuilderUsersReducer,
    listBuilderUsersEpic,
};
